import { defineStore } from 'pinia';
import { reactive, markRaw } from 'vue';

/**
 * Фабрика создания store для регистрации компонентов по типу.
 * @param {string} storeId - Уникальный идентификатор store (Pinia ID)
 */
export function createComponentStore(storeId) {
  return defineStore(storeId, () => {
    const components = reactive({});

    function register(type, component) {
      components[type] = markRaw(component);
    }

    function getComponentByType(type) {
      return components[type] || null;
    }

    return {
      register,
      getComponentByType
    };
  });
}
